import { useEffect } from "react";

const TeclaEscEnter =(onCancel, onSubmit) => {
    useEffect(() => {
      const handleKeyDown = (event) => {
        if (event.key === "Escape" && typeof onCancel === "function") {
          onCancel(); // Executa la funció de Cancel·lar
        }
        if (event.key === "Enter" && typeof onSubmit === "function") {
          onSubmit(); // Executa la funció d'Acceptar
        }
      };
  
      window.addEventListener("keydown", handleKeyDown);
  
      return () => {
        window.removeEventListener("keydown", handleKeyDown);
      };
    }, [onCancel, onSubmit]);
  };
  
  export default TeclaEscEnter;
